import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, Form, Checkbox } from "antd";
import { addInhoudingen } from "../../redux/actions/formActions";
import { hideMiscModal } from "../../redux/actions/miscActions";

export class InhoudingenForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: "",
      bedrag: "",
      isBedrag: true,
      belastbaar: true,
    };
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleNumberInput = (e) => {
    if (e.target.value.match(/^[0-9]+([0-9.]{1,3})?$/gm)) {
      this.setState({
        // [e.target.name]: e.target.value
        [e.target.name]: parseFloat(e.target.value),
      });
    } else if (e.target.value.length === 0) {
      this.setState({
        [e.target.name]: "",
      });
    }
  };

  handleIsBedrag = (e) => {
    this.setState({
      isBedrag: !e.target.checked,
    });
  };

  handleBelastbaar = (e) => {
    this.setState({
      belastbaar: e.target.checked,
    });
  };

  handleSubmit = () => {
    const { inhoudingen } = this.props.formData;
    inhoudingen.push(this.state);
    this.props.addInhoudingen(inhoudingen);
    this.setState({
      label: "",
      bedrag: "",
      isBedrag: false,
      belastbaar: true,
    });
    this.props.hideMiscModal();
  };
  render() {
    const { label, bedrag, isBedrag, belastbaar } = this.state;
    return (
      <div className="toelagen-form">
        <h3>Inhoudingen toevoegen</h3>
        <Form layout="vertical">
          <Form.Item>
            <Input
              placeholder="Label"
              name="label"
              onChange={this.handleInput}
              value={label}
              size={!!navigator.maxTouchPoints ? "large" : "default"}
            />
          </Form.Item>
          <Form.Item>
            <Input
              name="bedrag"
              placeholder="Bedrag/percentage"
              onChange={this.handleNumberInput}
              value={bedrag}
              suffix={!isBedrag ? <i className="fas fa-percentage"></i> : " "}
              size={!!navigator.maxTouchPoints ? "large" : "default"}
            />
          </Form.Item>

          <Checkbox checked={!isBedrag} onChange={this.handleIsBedrag}>
            Percentage
          </Checkbox>
          <Checkbox checked={belastbaar} onChange={this.handleBelastbaar}>
            Belastbaar
          </Checkbox>
        </Form>
        <button className="submit-form" onClick={this.handleSubmit}>
          Toevoegen
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
});

export default connect(mapStateToProps, { addInhoudingen, hideMiscModal })(
  InhoudingenForm
);
